import { useMediaQuery, useTheme } from '@mui/material';

export const useToolbarHeight = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  return isDesktop ? theme.toolbar.desktopHeight : theme.toolbar.mobileHeight;
};
